
// Estilos
import estilos from './pageWork.module.css';

// Componentes
import Background from "../../elements/backgrounds/background";
import LabelMenu from '../../elements/labels/labelMenu';

// Data
import { TEXT } from "../../../utils/varGlobal";

function PageWork(){

    function fomatearTexto(){
        let texto = ""

        TEXT.work.TEXT.forEach(elemento => {
            console.log(typeof(elemento))

            if(typeof(elemento) != "string")
                texto += elemento.join("\n") + "\n\n";
            else
                texto += elemento + "\n\n";
        })

        return texto;
    }

    return (
        <main>
            <Background>
                <LabelMenu opcion='work' goBack={true}/>
                <p id={estilos.text}>
                    {fomatearTexto()}
                </p>
            </Background>
        </main>
    )
}

export default PageWork;